import Loadable from 'react-loadable';
import Loading from 'src/components/Loading';

export default (loader: any) =>
  Loadable({
    loader,
    loading: Loading
  });



// WEBPACK FOOTER //
// ./src/utils/lazyLoad.tsx